module.exports = __webpack_public_path__ + "4ff1b7d5a2676130ab906df739513cb5.jpg";